import { CloseOutline } from 'antd-mobile-icons';
import styles from '../index.module.scss';
import { Button, Grid, TextArea } from 'antd-mobile';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { approvalDelayEnergyConsumption } from '@/api/energy';
import { ApprovalStatus } from '../util';

export interface ApprovalProp {
  onCancel: () => void;
  level: number;
}
const Approval = ({ onCancel, level }: ApprovalProp) => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [value, setValue] = useState('');

  const onSubmit = (status: ApprovalStatus) => {
    approvalDelayEnergyConsumption({
      id: Number(id),
      level,
      approvalDetail: {
        approvalResult: status,
        remark: value,
      },
    }).then(() => navigate('/intelligent-platform/energyUse/application'));
  };

  return (
    <div className={styles.popupContainer}>
      <div className={styles.popupTitleContainer}>
        <div className={styles.popupTitle}>审批</div>
        <CloseOutline onClick={onCancel} />
      </div>
      <div className={styles.popupMain}>
        备注
        <TextArea placeholder="请输入备注信息" rows={5} onChange={setValue} />
      </div>
      <div className={styles.actionBar}>
        <Grid columns={3} gap={12}>
          <Grid.Item>
            <Button size="large" onClick={onCancel}>
              取消
            </Button>
          </Grid.Item>
          <Grid.Item>
            <Button size="large" color="danger" fill="solid" onClick={() => onSubmit(ApprovalStatus.REJECTED)}>
              驳回
            </Button>
          </Grid.Item>
          <Grid.Item>
            <Button size="large" color="primary" fill="solid" onClick={() => onSubmit(ApprovalStatus.APPROVED)}>
              通过
            </Button>
          </Grid.Item>
        </Grid>
      </div>
    </div>
  );
};

export default Approval;
